import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * 自定义 Hook 用于动态设置页面标题（支持国际化）
 * @param {string} titleKey - 翻译键名（如 'home', 'connectUs'）
 * @param {boolean} [useDefault=false] - 是否使用默认标题（仅用于首页）
 */
export const useDocumentTitle = (titleKey, useDefault = false) => {
  const { t } = useTranslation();
  
  useEffect(() => {
    if (useDefault) {
      // 使用默认首页标题
      document.title = t('pageTitle.home');
    } else if (titleKey) {
      // 使用指定页面的标题
      document.title = t(`pageTitle.${titleKey}`);
    } else {
      // 回退到默认标题
      document.title = t('pageTitle.home');
    }
    
    // 清理函数：当组件卸载时恢复默认标题
    return () => {
      document.title = t('pageTitle.home');
    };
  }, [titleKey, useDefault, t]);
};
